export default function OverviewTab({ d }) {
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <div className="card">
        <h3 className="font-serif text-2xl mb-3">Currently in the villa</h3>
        {d.current_guests.length === 0 && <p className="text-sm" style={{ color: "var(--muted)" }}>No guests currently checked in.</p>}
        {d.current_guests.map((s) => (
          <div key={s.id} className="py-3 border-b last:border-0" style={{ borderColor: "var(--border)" }} data-testid={`current-guest-${s.id}`}>
            <div className="font-medium">{s.guest_name}</div>
            <div className="text-sm" style={{ color: "var(--muted)" }}>{s.check_in_date} → {s.check_out_date} · {s.total_pax} guests · {s.guest_mobile}</div>
          </div>
        ))}
      </div>
      <div className="card">
        <h3 className="font-serif text-2xl mb-3">Live activity</h3>
        <div className="space-y-2 max-h-96 overflow-auto">
          {d.activity.map((n) => (
            <div key={n.id} className="text-sm py-2 border-b last:border-0" style={{ borderColor: "var(--border)" }} data-testid={`activity-${n.id}`}>
              <div className="text-xs" style={{ color: "var(--muted)" }}>{new Date(n.created_at).toLocaleTimeString()}</div>
              <div><b>{n.title}</b> — {n.message}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
